<script>
    import { onMount } from "svelte";

    import Select from "svelte-select/Select.svelte";

    import {
        CardLayout,
        Loader,
    } from "../../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../../Services/index.svelte";

    import {
        AustralianStates,
        DirectInsuranceType,
        InsuranceType,
        defaultState,
    } from "../../../../Utils/utilEnums.svelte";

    import {
        insuranceFund,
        workersCompensation,
        trafficAccidentAuthorities,
        loggedInDoctorDetail,
    } from "../../../../stores";

    import {
        checkMedicareNoValidation,
        getDvaStringValidation,
        getEmailValidation,
        getPrivateInsuranceFundCoverTypes,
        getPrivateInsuranceFundDefaultCoverType,
        goToDownloadPage,
        isObjectEmpty,
        privateInsuranceFundHasCoverTypes,
        showError,
        showException,
        showInfo,
    } from "../../../../Utils/utilFunctions.svelte";

    import {
        cacheInsuranceFunds,
        cacheTrafficAccidentAuthorities,
        cacheWorkersCompensation,
    } from "../../../../Utils/utilCache.svelte";

    import {
        addErrorInput,
        removeErrorInput,
    } from "../../helpers/encounterUtils.svelte";

    import {
        hideMedicareInsurance,
        noNeedForMedicareNoArr,
        unknownPatientInsuranceType,
    } from "../../../../Utils/utilConstants.svelte";

    import OpvStatusModal from "../OpvStatusModal.svelte";

    import { enablePatientClaimForEncounter } from "../../helpers/encounterHelper.svelte";

    export let patientDetails = {},
        patientEncounterDetails = {},
        insuranceDetails = {},
        workerCompensation,
        workerCompensationObj = {},
        trafficAuthority,
        trafficAuthorityObj = {},
        publicInPrivateObj = {},
        thirdPartyPayerObj = {},
        defenceDataObj = {},
        selectedHospital = {},
        selectedDoctorProvider = {},
        createSurgeonFilters = {},
        disableInputScenario_ONE = false,
        disableInputScenario_TWO = false,
        isEncounterEnablePartiallyEditOnly = false,
        hasReceivedPayments = false,
        UNLOCK_ALL_INPUTS = false,
        overrideValidation = false,
        isFromCreate = false;

    $: showUnlockInsuranceInputTooltips =
        hasReceivedPayments && UNLOCK_ALL_INPUTS;

    $: showWarningInsuranceInputText =
        isEncounterEnablePartiallyEditOnly &&
        UNLOCK_ALL_INPUTS &&
        (__BACKUP__INSURANCE__TYPE__ != patientDetails.insuranceType ||
            __BACKUP__INSURANCE__FUND__?.id !=
                insuranceDetails?.insuranceFund?.id ||
            (showCoverTypeForPrivateInsurance &&
                __BACKUP__PRIVATE__COVER__TYPE__ !=
                    insuranceDetails.privateCoverType));

    $: if (patientDetails.insuranceType == 0 || patientDetails.insuranceType == 10) loadInsuranceFund();

    $: if (patientDetails.insuranceType == 16) loadWorkerCompensation();

    $: if (patientDetails.insuranceType == 16 && $workersCompensation.length)
        _syncDisplayOptionsByState();

    $: if (patientDetails.insuranceType == 17) loadTrafficAuthorities();

    $: if (
        patientDetails.insuranceType == 17 &&
        $trafficAccidentAuthorities.length
    )
        _syncDisplayOptionsByState();

    $: if (
        patientDetails.insuranceType == DirectInsuranceType.ThirdPartyInsurer &&
        !hasFetchedThirdPartyInsurers && $loggedInDoctorDetail.id
    )
        loadThirdPartyInsurers();

    $: showCoverTypeForPrivateInsurance =
        patientDetails.insuranceType == 0 &&
        insuranceDetails?.insuranceFund?.id &&
        privateInsuranceFundHasCoverTypes(insuranceDetails.insuranceFund.id);

    $: isValidMedicareNo =
        hideMedicareInsurance.includes(Number(patientDetails.insuranceType)) ||
        Number(patientDetails.insuranceType) == unknownPatientInsuranceType ||
        overrideValidation
            ? true
            : patientDetails.medicareNo
              ? checkMedicareNoValidation(patientDetails.medicareNo)
              : noNeedForMedicareNoArr.includes(
                    Number(patientDetails.insuranceType),
                );

    $: isValidInsurerEmail = overrideValidation
        ? true
        : workerCompensationObj.insurerEmail
          ? getEmailValidation(workerCompensationObj.insurerEmail)
          : true;

    $: isValidTrafficAuthorityEmail = overrideValidation
        ? true
        : trafficAuthorityObj.email
          ? getEmailValidation(trafficAuthorityObj.email)
          : true;

    $: isValidEmployerEmail = overrideValidation
        ? true
        : insuranceDetails.employerEmail
          ? getEmailValidation(insuranceDetails.employerEmail)
          : true;

    $: isValidPipEmail = overrideValidation
        ? true
        : publicInPrivateObj.email
          ? getEmailValidation(publicInPrivateObj.email)
          : true;

    $: isValidThirdPartyPayerEmail = overrideValidation
        ? true
        : thirdPartyPayerObj.email
          ? getEmailValidation(thirdPartyPayerObj.email)
          : true;

    $: isValidThirdPartyPayerPhone = overrideValidation
        ? true
        : thirdPartyPayerObj.phone
          ? thirdPartyPayerObj.phone.length >= 6
          : true;

    $: isValidDvaNumber =
        patientDetails.insuranceType != 20 || overrideValidation
            ? true
            : getDvaStringValidation(patientDetails.veteranNo);

    $: showOpvCheckBtn = _ToggleOpvCheckBtnVisibility(
        patientDetails,
        insuranceDetails,
        disableInputScenario_ONE,
        disableInputScenario_TWO,
        UNLOCK_ALL_INPUTS,
    );

    $: if (UNLOCK_ALL_INPUTS) _resetInputDisability();

    $: if ($loggedInDoctorDetail.providers?.length) _setDefaultDoctorProvider();

    $: if (
        showCoverTypeForPrivateInsurance &&
        insuranceDetails?.privateCoverType
    )
        __BACKUP__PRIVATE__COVER__TYPE__ = insuranceDetails.privateCoverType;

    /* 
        Flag to show patient claim checkbox if:
        1. in Edit flow
        3. enablePatientClaimForEncounter is TRUE
    */
    $: showPatientClaimCheckbox =
        !isFromCreate &&
        [
            DirectInsuranceType.Private,
            DirectInsuranceType.SelfInsured,
        ].includes(patientDetails.insuranceType) &&
        enablePatientClaimForEncounter({
            ...patientEncounterDetails,
            patient: patientDetails,
        });

    $: showDownloadPatientClaimDocument =
        patientEncounterDetails.patientClaim &&
        patientDetails.insuranceType == 0;

    const defaultOverseasFund = {
                                    id: 0,
                                    name: "Other Overseas Insurance"
                                };

    let hasInsuranceFundFetched = false,
        isLoadingInsuranceFund = false;

    let hasWorkerCompensationFetched = false,
        isLoadingWorkerCompensation = false,
        workerCompensationOptions = [];

    let hasTrafficAuthoritiesFetched = false,
        isLoadingTrafficAuthorities = false,
        trafficAuthorityOptions = [];

    let doctorDefaultPrivateInsuranceFundCoverTypes = [],
        hasDefaultPrivateInsuranceFundCoverTypesFetched = false;

    let errInputs = [];

    let isCheckingOPV = false,
        opvResultModalOpen = false,
        opvResult = {};

    let __BACKUP__INSURANCE__TYPE__,
        __BACKUP__INSURANCE__FUND__,
        __BACKUP__PRIVATE__COVER__TYPE__,
        showWarningInsuranceInputText = false;

    let skipWorkCoverClaimNo = false,
        skipTrafficAuthorityClaimNo = false,
        skipDefenceClaimNo = false;

    let isLoadingThirdPartyInsurers = false,
        thirdPartyInsurers = [],
        hasFetchedThirdPartyInsurers = false;

    let isLoadingDoctor = false;

    const unlockInsuranceInputTooltip =
        "Changing insurance type, fund or cover for encounters with quotes or invoices will cancel them. Please remember to recreate the quote or invoices and move the payments to them if necessary";

    const warningInsuranceInputText =
        "Warning - changing the patient insurance details will reset the billing rule and cancel all the encounter quotes and invoices.";

    // const skipWcAndTacText =
    //     "I don't have the claim ID. Please get support to follow up on it.";
    // const skipDefenceText =
    //     "I don't have the PID and/or DAN. Please get support to follow up on them.";
    const skipWcAndTacText = "I don't have the claim ID.";
    const skipDefenceText = "I don't have the PID and/or DAN.";

    onMount(() => {
        if (patientDetails.insuranceType == 16) _syncWorkCompensation();
        else if (patientDetails.insuranceType == 17) _syncTrafficAuthorities();

        !UNLOCK_ALL_INPUTS &&
            disableInputScenario_TWO &&
            _syncInputDisability();

        if (isEncounterEnablePartiallyEditOnly)
            _setDefaultPrivateInsuranceDetails();
    });

    export const loadSelectedDoctor = async () => {
        isLoadingDoctor = true;

        await apiMethods.getMethod
            .getAccountById($loggedInDoctorDetail.id)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to load selected doctor's providers, please refresh the page and try again and contact support if the issue persists.",
                    );
                else $loggedInDoctorDetail = { ...res };
            });

        isLoadingDoctor = false;
    };

    export const checkInsuranceDetailsValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    export const loadInsuranceFund = async () => {
        if (!$insuranceFund.length && !hasInsuranceFundFetched) {
            hasInsuranceFundFetched = true;

            isLoadingInsuranceFund = true;

            await cacheInsuranceFunds();

            isLoadingInsuranceFund = false;
        }

        if (patientDetails.insuranceId) _syncInsuranceFund();

        if (
            !doctorDefaultPrivateInsuranceFundCoverTypes.length &&
            !hasDefaultPrivateInsuranceFundCoverTypesFetched &&
            $loggedInDoctorDetail.id
        ) {
            hasDefaultPrivateInsuranceFundCoverTypesFetched = true;

            await apiMethods.getMethod
                .getAccountInsuranceDefaultCover($loggedInDoctorDetail.id)
                .then((res) => {
                    if (!res || res.error)
                        showError(
                            res.error ??
                                "Failed to load doctor's default insurance fund cover types, please refresh the page and try again and contact support if the issue persists.",
                        );
                    else doctorDefaultPrivateInsuranceFundCoverTypes = [...res];
                });
        }

        !UNLOCK_ALL_INPUTS &&
            disableInputScenario_TWO &&
            _syncInputDisability();
    };

    export const loadWorkerCompensation = async (syncData = true) => {
        if (!$workersCompensation.length && !hasWorkerCompensationFetched) {
            hasWorkerCompensationFetched = true;

            isLoadingWorkerCompensation = true;

            await cacheWorkersCompensation();

            isLoadingWorkerCompensation = false;
        }

        syncData && _syncWorkCompensation();

        _syncDisplayOptionsByState();

        !UNLOCK_ALL_INPUTS &&
            disableInputScenario_TWO &&
            _syncInputDisability();
    };

    export const loadTrafficAuthorities = async (syncData = true) => {
        if (
            !$trafficAccidentAuthorities.length &&
            !hasTrafficAuthoritiesFetched
        ) {
            hasTrafficAuthoritiesFetched = true;

            isLoadingTrafficAuthorities = true;

            await cacheTrafficAccidentAuthorities();

            isLoadingTrafficAuthorities = false;
        }

        syncData && _syncTrafficAuthorities();

        _syncDisplayOptionsByState();

        !UNLOCK_ALL_INPUTS &&
            disableInputScenario_TWO &&
            _syncInputDisability();
    };

    const loadThirdPartyInsurers = async () => {
        if (isLoadingThirdPartyInsurers) return;

        isLoadingThirdPartyInsurers = true;

        await apiMethods.getMethod
            .getThirdPartyInsurers(0, 999999, {
                "filter[doctorId]": $loggedInDoctorDetail.id,
            })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to load third party insurers, please refresh the page and try again and contact support if the issue persists.",
                    );
                else {
                    thirdPartyInsurers = [...res.results];
                    hasFetchedThirdPartyInsurers = true;
                }
            });

        await loadThirdPartyInsurerSuggestions();

        isLoadingThirdPartyInsurers = false;
    };

    const loadThirdPartyInsurerSuggestions = async () =>
        await apiMethods.getMethod
            .getThirdPartyInsurerSuggestions($loggedInDoctorDetail.id)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res?.error ??
                            "Failed to load third party insurer suggestions, please refresh the page and try again and contact support if the issue persists.",
                    );
                else {
                    const suggestedInsurers = res.results;

                    if (!suggestedInsurers.length) return;

                    const result = [];

                    const suggestedInsurerIds = [];
                    const len = Math.min(suggestedInsurers.length, 5);

                    suggestedInsurers
                    .slice(0, 5)
                    .forEach((suggestion) => {
                        const insurer = thirdPartyInsurers.find(i => i.name.toLowerCase() === suggestion.name.toLowerCase());
                        if (!insurer) return; // continue

                        result.push({
                            ...insurer,
                            groupName: "Suggested Insurers",
                        });

                        suggestedInsurerIds.push(insurer.id);
                    });

                    thirdPartyInsurers.map((insurer) => {
                        if (!suggestedInsurerIds.includes(insurer.id))
                            result.push({
                                ...insurer,
                                groupName: "Other Insurers",
                            });
                    });

                    thirdPartyInsurers = [...result];
                }
            });

    const clearCurrentInsuranceFund = () => {
        insuranceDetails.insuranceFund = null;

        if (insuranceDetails.privateCoverType)
            delete insuranceDetails.privateCoverType;

        const insuranceFundContainer = document.getElementById(
            "insuranceFundContainer",
        );
        const insuranceFundSelect = document.getElementById(
            "insuranceFundSelect",
        );
        insuranceFundContainer.style.outline = "";
        insuranceFundSelect.placeholder = "Insurance fund";
    };

    const handleSelectInsuranceFund = () => {
        if (
            insuranceDetails.insuranceFund &&
            doctorDefaultPrivateInsuranceFundCoverTypes.some(
                (type) => type.insuranceId == insuranceDetails.insuranceFund.id,
            )
        ) {
            insuranceDetails.privateCoverType =
                doctorDefaultPrivateInsuranceFundCoverTypes.find(
                    (type) =>
                        type.insuranceId == insuranceDetails.insuranceFund.id,
                ).insurance;
        } else
            insuranceDetails.privateCoverType =
                getPrivateInsuranceFundDefaultCoverType(
                    insuranceDetails.insuranceFund.id,
                );

        const insuranceFundContainer = document.getElementById(
            "insuranceFundContainer",
        );
        const insuranceFundSelect = document.getElementById(
            "insuranceFundSelect",
        );
        insuranceFundContainer.style.outline = "";
        insuranceFundSelect.placeholder = "";
    };

    const clearWorkerCompensation = () => {
        workerCompensation = null;
        patientEncounterDetails.patientEncounterWorkCoverData.workCoverAuthority = null;

        const workerCompensationContainer = document.getElementById(
            "workerCompensationContainer",
        );
        const workerCompensationSelect = document.getElementById(
            "workerCompensationSelect",
        );

        if (workerCompensationContainer)
            workerCompensationContainer.style.outline = "";
        if (workerCompensationSelect)
            workerCompensationSelect.placeholder =
                "Workcover insurer (if known)";
    };

    const updateWorkcoverInsurerEmail = () =>
        (workerCompensationObj.insurerEmail = workerCompensation.email);

    const clearTrafficAuthority = () => {
        trafficAuthority = null;

        const trafficAuthoritiesContainer = document.getElementById(
            "trafficAuthoritiesContainer",
        );

        const trafficAuthoritySelect = document.getElementById(
            "trafficAuthoritySelect",
        );

        if (trafficAuthoritiesContainer)
            trafficAuthoritiesContainer.style.outline = "";
        if (trafficAuthoritySelect)
            trafficAuthoritySelect.placeholder = "Traffic Accident Authority";
    };

    const updateTrafficAuthorityEmail = () =>
        (trafficAuthorityObj.email = trafficAuthority.email);

    const runOpvCheck = async () => {
        if (isCheckingOPV) return;

        isCheckingOPV = true;

        if (patientDetails.insuranceType == 0)
            patientDetails = {
                ...patientDetails,
                insuranceId: insuranceDetails.insuranceFund.id,
                membershipNo: insuranceDetails.membershipNo,
                membershipRefNo: insuranceDetails.membershipRefNo,
            };

        if (patientDetails.medicareRefNo)
            patientDetails.medicareRefNo = Number(patientDetails.medicareRefNo);

        patientDetails.title =
            patientDetails.title.toString().toLowerCase() == "title"
                ? 20
                : patientDetails.title;

        await apiMethods.postMethod
            .checkOPV(patientDetails, true)
            .then((res) => {
                // if (!res || res.error)
                //     showError(
                //         res.error ??
                //             "Failed opv check process, please refresh the page and try again and contact support if the issue persists.",
                //     );
                // else _openOpvResultModal(res);
                _openOpvResultModal(res);
            })
            .catch((err) => showException(err));

        isCheckingOPV = false;
    };

    export const clearSelectedDoctorProvider = (showPlaceholder = true) => {
        selectedDoctorProvider = {};

        const doctorProviderSelect = document.getElementById(
            "doctorProviderSelect",
        );

        const doctorProviderContainer = document.getElementById(
            "doctorProviderContainer",
        );

        doctorProviderSelect.placeholder = showPlaceholder
            ? "Doctor provider"
            : "";
        doctorProviderContainer.style.outline = "";
    };

    const onProviderChange = async () => {
        const selectedProvider = selectedDoctorProvider.details;
        patientEncounterDetails.overrideProviderNumber = true; //manually changed by user
        showInfo("Manual override of the doctor provider number");

        if (!selectedProvider?.id) return;

        _setProviderState(selectedProvider.state);

        const selectedProviderHospitalsArr = selectedProvider.hospitals.map(
            (hospital) => hospital.hospitalId,
        );

        if (patientDetails?.insuranceType == 30) _syncPipInsuranceData();

        if (!selectedProviderHospitalsArr.length) return;

        const firstProviderHospitalId = selectedProviderHospitalsArr[0];

        let potentialHospital = await apiMethods.getMethod.getHospitalById(
            firstProviderHospitalId,
        );

        if (!potentialHospital?.id || selectedHospital?.details?.id) return;

        selectedHospital.details = { ...potentialHospital };
    };

    const handleDownloadPatientClaimDocument = () => goToDownloadPage(15, 0);

    const handleSkipWorkCoverClaimNo = () => {
        if (skipWorkCoverClaimNo) {
            const workerCompensationClaimNumberInput = document.getElementById(
                "workerCompensationClaimNumberInput",
            );
            workerCompensationClaimNumberInput.style.outline = "";
            workerCompensationClaimNumberInput.placeholder =
                "Worker compensation claim number";
        }
    };

    const handleSkipTacClaimNo = () => {
        if (skipTrafficAuthorityClaimNo) {
            const trafficAuthorityClaimNumberInput = document.getElementById(
                "trafficAuthorityClaimNumberInput",
            );
            trafficAuthorityClaimNumberInput.style.outline = "";
            trafficAuthorityClaimNumberInput.placeholder =
                "Traffic Accident Authority claim number";

            const trafficAuthoritiesContainer = document.getElementById(
                "trafficAuthoritiesContainer",
            );
            if (trafficAuthoritiesContainer)
                trafficAuthoritiesContainer.style.outline = "";
        }
    };

    const handleSkipDefenceClaimNo = () => {
        if (skipDefenceClaimNo) {
            const insuranceDetailsPIDField = document.getElementById(
                "insuranceDetailsPIDField",
            );
            insuranceDetailsPIDField.style.outline = "";
            insuranceDetailsPIDField.placeholder = "PID";

            const insuranceDetailsDANField = document.getElementById(
                "insuranceDetailsDANField",
            );
            insuranceDetailsDANField.style.outline = "";
            insuranceDetailsDANField.placeholder = "DAN";
        }
    };

    const groupBy = (option) => option.groupName;

    // HELPER FUNCTIONS
    const _ToggleOpvCheckBtnVisibility = (
        pDetails = {},
        iDetails = {},
        disableScenarioOne = false,
        disableScenarioTwo = false,
        unlockAllInputs = false,
    ) => {
        if (!unlockAllInputs && (disableScenarioOne || disableScenarioTwo))
            return false;

        const { insuranceType, medicareNo } = pDetails;

        if (
            insuranceType == "Insurance Type" ||
            insuranceType == unknownPatientInsuranceType
        )
            return false;

        const allowOpvCheckInsuranceTypes = [0, 11, 20];

        if (!allowOpvCheckInsuranceTypes.includes(insuranceType)) return false;

        switch (insuranceType) {
            case 0:
                const { insuranceFund } = iDetails;
                return isValidMedicareNo && insuranceFund && insuranceFund.id;
            case 11:
                return isValidMedicareNo;
            case 20:
                return (medicareNo && isValidMedicareNo) || isValidDvaNumber;
            default:
                return false;
        }
    };

    const _updateInvalidFieldsStyle = () => {
        if (!selectedDoctorProvider?.details?.id)
            errInputs = addErrorInput("doctorProviderContainer", errInputs);

        const patientInsuranceTypeSelect = document.getElementById(
            "patientInsuranceTypeSelect",
        );
        if (
            patientInsuranceTypeSelect.value == "Insurance Type" &&
            !overrideValidation
        )
            errInputs = addErrorInput("patientInsuranceTypeSelect", errInputs);
        else if (patientInsuranceTypeSelect.value == "Insurance Type")
            patientDetails.insuranceType = unknownPatientInsuranceType;
        else {
            const { medicareRefNo } = patientDetails;

            const insuranceType = patientInsuranceTypeSelect.value;

            if (
                insuranceType != 15 &&
                Number(insuranceType) != unknownPatientInsuranceType
            ) {
                if (!isValidMedicareNo)
                    errInputs = addErrorInput(
                        "patientMedicareNoField",
                        errInputs,
                        "Medicare No.",
                    );
                else if (insuranceType != 10 && InsuranceType != 18)
                    errInputs = removeErrorInput(
                        "patientMedicareNoField",
                        errInputs,
                        "Medicare No.",
                    );

                if (
                    !medicareRefNo &&
                    !noNeedForMedicareNoArr.includes(Number(insuranceType)) &&
                    !overrideValidation
                )
                    errInputs = addErrorInput(
                        "patientMedicareRefNoField",
                        errInputs,
                        "Medicare Ref No.",
                    );
                else if (insuranceType != 10 && InsuranceType != 18)
                    errInputs = removeErrorInput(
                        "patientMedicareRefNoField",
                        errInputs,
                        "Medicare Ref No.",
                    );

                if ((insuranceType == 0 || insuranceType == 10) && !overrideValidation) {
                    if ((insuranceType == 0 && !insuranceDetails.insuranceFund?.id) || (insuranceType == 10 && !insuranceDetails.insuranceFund))
                        errInputs = addErrorInput(
                            "insuranceFundContainer",
                            errInputs,
                            "Insurance fund",
                        );
                    if ((insuranceType == 0 && !insuranceDetails.membershipNo) || (insuranceType == 10 && insuranceDetails.insuranceFund?.id != 0 && !insuranceDetails.membershipNo))
                        errInputs = addErrorInput(
                            "insuranceDetailsMembershipNoField",
                            errInputs,
                            "Membership No",
                        );
                } else {
                    errInputs = removeErrorInput(
                            "insuranceFundContainer",
                            errInputs,
                            "Insurance fund",
                        );
                    errInputs = removeErrorInput(
                            "insuranceDetailsMembershipNoField",
                            errInputs,
                            "Membership No",
                        );
                }

                if (insuranceType == 16) _checkWorkersCompValue();

                if (insuranceType == 17) _checkTrafficAuthorityValue();

                if (insuranceType == 18 && !overrideValidation) {
                    if (!thirdPartyPayerObj.name)
                        errInputs = addErrorInput(
                            "thirdPartyPayerNameInput",
                            errInputs,
                            "Payer name",
                        );

                    if (
                        !thirdPartyPayerObj.address &&
                        !thirdPartyPayerObj.email
                    ) {
                        errInputs = addErrorInput(
                            "thirdPartyPayerAddressInput",
                            errInputs,
                            "",
                        );
                        errInputs = addErrorInput(
                            "thirdPartyPayerEmailInput",
                            errInputs,
                            "",
                        );
                    }
                } else 
                {
                    errInputs = removeErrorInput(
                        "thirdPartyPayerNameInput",
                        errInputs,
                        "Payer name",
                    );
                    errInputs = removeErrorInput(
                        "thirdPartyPayerAddressInput",
                        errInputs,
                        "",
                    );
                    errInputs = removeErrorInput(
                        "thirdPartyPayerEmailInput",
                        errInputs,
                        "",
                    );
                }

                if (insuranceType == 20 && !isValidDvaNumber && !overrideValidation) {
                    errInputs = addErrorInput(
                        "insuranceDetailsDVANumberField",
                        errInputs,
                        "Veteran number",
                    );
                } else {
                    errInputs = removeErrorInput(
                        "insuranceDetailsDVANumberField",
                        errInputs,
                        "Veteran number",
                    );
                }

                if (
                    (insuranceType == 25 || insuranceType == 26) &&
                    !overrideValidation &&
                    !skipDefenceClaimNo
                ) {
                    if (!defenceDataObj.pid)
                        errInputs = addErrorInput(
                            "insuranceDetailsPIDField",
                            errInputs,
                            "PID",
                        );
                    if (!defenceDataObj.dan)
                        errInputs = addErrorInput(
                            "insuranceDetailsDANField",
                            errInputs,
                            "DAN",
                        );
                } else {
                    errInputs = removeErrorInput(
                        "insuranceDetailsPIDField",
                        errInputs,
                        "PID",
                    );
                    errInputs = removeErrorInput(
                        "insuranceDetailsDANField",
                        errInputs,
                        "DAN",
                    );
                }

                if (
                    insuranceType == 30 &&
                    publicInPrivateObj.email &&
                    !isValidPipEmail
                ) {
                    errInputs = addErrorInput(
                        "pipEmailInput",
                        errInputs,
                        "Email to send invoice",
                    );
                }
            } else if (!isValidMedicareNo)
                errInputs = addErrorInput(
                    "patientMedicareNoField",
                    errInputs,
                    "Medicare No.",
                );
        }
    };

    const _checkWorkersCompValue = () => {
        if(overrideValidation) {

        }
        const pairOneMissing =
            !overrideValidation &&
            (!workerCompensation?.id ||
                (workerCompensation.id &&
                    !skipWorkCoverClaimNo &&
                    !workerCompensationObj.claimNumber) ||
                !isValidInsurerEmail);

        const pairTwoMissing =
            !overrideValidation &&
            (!insuranceDetails.employer ||
                !insuranceDetails.employerEmail ||
                (insuranceDetails.employerEmail && !isValidEmployerEmail));

        if (
            (pairOneMissing && !pairTwoMissing) ||
            (!pairOneMissing && pairTwoMissing) || overrideValidation
        ) {
            const workerCompensationContainer = document.getElementById(
                "workerCompensationContainer",
            );
            workerCompensationContainer.style.outline = "";
            workerCompensationContainer.style.borderRadius = "5px";

            errInputs = removeErrorInput(
                "workerCompensationInsurerEmailInput",
                errInputs,
                "Workcover insurer email",
            );
            errInputs = removeErrorInput(
                "workerCompensationClaimNumberInput",
                errInputs,
                "Worker compensation claim number",
            );
            errInputs = removeErrorInput(
                "insuranceDetailsEmployerField",
                errInputs,
                "Employer",
            );
            errInputs = removeErrorInput(
                "insuranceDetailsEmployerEmailField",
                errInputs,
                "Employer email",
            );
        } else if (pairOneMissing && pairTwoMissing) {
            const workerCompensationContainer = document.getElementById(
                "workerCompensationContainer",
            );
            workerCompensationContainer.style.outline = "red solid 2px";
            workerCompensationContainer.style.borderRadius = "5px";

            if (!skipWorkCoverClaimNo)
                errInputs = addErrorInput(
                    "workerCompensationClaimNumberInput",
                    errInputs,
                    "Worker compensation claim number",
                );
            errInputs = addErrorInput(
                "insuranceDetailsEmployerField",
                errInputs,
                "Employer",
            );
            errInputs = addErrorInput(
                "insuranceDetailsEmployerEmailField",
                errInputs,
                "Employer email",
            );
        }

        if (!isValidInsurerEmail)
            errInputs = addErrorInput(
                "workerCompensationInsurerEmailInput",
                errInputs,
            );

        if (!isValidEmployerEmail)
            errInputs = addErrorInput(
                "insuranceDetailsEmployerEmailField",
                errInputs,
            );
    };

    const _checkTrafficAuthorityValue = () => {
        if (
            !overrideValidation &&
            !trafficAuthority?.id &&
            !skipTrafficAuthorityClaimNo &&
            !overrideValidation
        ) {
            const trafficAuthoritiesContainer = document.getElementById(
                "trafficAuthoritiesContainer",
            );
            trafficAuthoritiesContainer.style.outline = "red solid 2px";
            trafficAuthoritiesContainer.style.borderRadius = "5px";
            errInputs = addErrorInput("trafficAuthoritiesContainer", errInputs);
        } else {
            const trafficAuthoritiesContainer = document.getElementById(
                "trafficAuthoritiesContainer",
            );
            trafficAuthoritiesContainer.style.outline = "";
            trafficAuthoritiesContainer.style.borderRadius = "5px";
            errInputs = removeErrorInput("trafficAuthoritiesContainer", errInputs);    
        }

        if (
            trafficAuthority?.id &&
            !isValidTrafficAuthorityEmail &&
            !overrideValidation
        )
            errInputs = addErrorInput(
                "trafficAuthorityEmailInput",
                errInputs,
                "Traffic Accident Authority email",
            );
        else {
            errInputs = removeErrorInput(
                "trafficAuthorityEmailInput",
                errInputs,
                "Traffic Accident Authority email",
            );
        }

        if (
            !trafficAuthorityObj.claimNumber &&
            !overrideValidation &&
            !skipTrafficAuthorityClaimNo
        )
            errInputs = addErrorInput(
                "trafficAuthorityClaimNumberInput",
                errInputs,
                "Claim number",
            );
        else {
            errInputs = removeErrorInput(
                "trafficAuthorityClaimNumberInput",
                errInputs,
                "Claim number",
            );
            }
    };

    export const _syncInsuranceFund = () => {
        if(patientDetails.insuranceType == 10 && patientDetails.insuranceId == 0) {
            //overseas insurance with other overseas fund selected
            insuranceDetails.insuranceFund = defaultOverseasFund;
            return;
        }
        insuranceDetails.insuranceFund = $insuranceFund.find(
            (fund) => fund.id == patientDetails.insuranceId,
        );
        insuranceDetails.membershipNo = patientDetails.membershipNo;
        insuranceDetails.membershipRefNo = patientDetails.membershipRefNo;

        insuranceDetails.privateCoverType = patientDetails.insurance;

        __BACKUP__INSURANCE__FUND__ = insuranceDetails.insuranceFund;
    };

    const _syncWorkCompensation = () => {
        if (
            $workersCompensation.length &&
            !workerCompensation?.id &&
            patientEncounterDetails.patientEncounterWorkCoverData
                ?.workCoverAuthority
        )
            workerCompensation = $workersCompensation.find(
                (compensation) =>
                    compensation.id ==
                    patientEncounterDetails.patientEncounterWorkCoverData
                        .workCoverAuthority,
            );
    };

    const _syncDisplayOptionsByState = () => {
        const { insuranceType, insuranceState } = patientDetails;

        if(insuranceType == 10) {
            //was changed to overseas, remove preselect the default overseas insurance fund
            insuranceDetails.insuranceFund = defaultOverseasFund;
        } else if (insuranceType == 0) {
            insuranceDetails.insuranceFund = null;
        }

        if (!showPatientClaimCheckbox)
            patientEncounterDetails.patientClaim = false;

        if (insuranceType == 16) {
            if (!$workersCompensation.length || !insuranceState) return;

            workerCompensationOptions = $workersCompensation.filter(
                ({ state }) =>
                    state.toLowerCase() == insuranceState.toLowerCase(),
            );

            if (
                workerCompensation &&
                workerCompensation.state?.toLowerCase() !=
                    insuranceState.toLowerCase()
            )
                clearWorkerCompensation();

            if (workerCompensationOptions.length == 1) {
                workerCompensation = workerCompensationOptions[0];
                updateWorkcoverInsurerEmail();
            }
        } else if (insuranceType == 17) {
            if (!$trafficAccidentAuthorities.length || !insuranceState) return;

            trafficAuthorityOptions = $trafficAccidentAuthorities.filter(
                ({ state }) =>
                    state.toLowerCase() == insuranceState.toLowerCase(),
            );

            if (
                trafficAuthority &&
                trafficAuthority.state?.toLowerCase() !=
                    insuranceState.toLowerCase()
            )
                clearTrafficAuthority();

            if (trafficAuthorityOptions.length == 1) {
                trafficAuthority = trafficAuthorityOptions[0];
                updateTrafficAuthorityEmail();
            }
        } else if (insuranceType == 30) _syncPipInsuranceData();
    };

    export const _syncPipInsuranceData = () => {
        if (!selectedHospital || !selectedHospital.details || isObjectEmpty(selectedHospital)) {
            publicInPrivateObj.email = "";
            publicInPrivateObj.vendorNumbers = "";
            return;
        }

        const { id } = selectedHospital.details;

        //check if hospital has pip details
        apiMethods.getMethod
            .getHospitalById(id)
            .then((res) => {
                if(res.hospitalPIPData) {
                    publicInPrivateObj.email = res.hospitalPIPData.email ?? "";
                } else {
                    publicInPrivateObj.email = "";
                }
            });
       
        const providerHospitals = selectedDoctorProvider.details.hospitals;

        if (!providerHospitals?.length) {
            publicInPrivateObj.vendorNumbers = "";
            return;
        }

        const targetHospital = providerHospitals.find(
            (hospital) => hospital.hospitalId == id,
        );

        if (!targetHospital) {
            publicInPrivateObj.vendorNumbers = "";
            return;
        }

        publicInPrivateObj.vendorNumbers = targetHospital.pipVendorNumber;
    };

    const _handleSelectThirdPartyInsurer = (e) => {
        const selectedInsurerId = e.detail.id;

        const selectedInsurer = thirdPartyInsurers.find(
            (insurer) => insurer.id == selectedInsurerId,
        );

        if (!selectedInsurer || isObjectEmpty(selectedInsurer)) return;

        const { name, email, phone, address, addGST } = selectedInsurer;

        thirdPartyPayerObj.name = name;
        thirdPartyPayerObj.email = email;
        thirdPartyPayerObj.phone = phone;
        thirdPartyPayerObj.address = address;
        thirdPartyPayerObj.addGST = addGST;
    };

    const _syncTrafficAuthorities = () => {
        if (
            $trafficAccidentAuthorities.length &&
            !trafficAuthority?.id &&
            patientEncounterDetails.patientEncounterTrafficAccidentData
                ?.trafficAccidentAuthority
        )
            trafficAuthority = $trafficAccidentAuthorities.find(
                (authority) =>
                    authority.id ==
                    patientEncounterDetails.patientEncounterTrafficAccidentData
                        .trafficAccidentAuthority,
            );

        if (trafficAuthority?.id)
            trafficAuthorityObj.email = trafficAuthority.email;
    };

    const _syncInputDisability = () => {
        const insuranceDetailsContainer = document.getElementById(
            "insuranceDetailsContainer",
        );

        if (!insuranceDetailsContainer) return;

        const allInputs = insuranceDetailsContainer.querySelectorAll("input");

        allInputs.forEach((input) => (input.disabled = true));

        const allSelects = insuranceDetailsContainer.querySelectorAll("select");

        allSelects.forEach((select) => (select.disabled = true));

        const { insuranceType } = patientDetails;

        if (insuranceType == 0) {
            const insuranceFundSelect = document.getElementById(
                "insuranceFundSelect",
            );
            if (insuranceFundSelect)
                insuranceFundSelect.style.cursor = "not-allowed";
        } else if (insuranceType == 16) {
            const workerCompensationSelect = document.getElementById(
                "workerCompensationSelect",
            );

            if (workerCompensationSelect)
                workerCompensationSelect.style.cursor = "not-allowed";
        } else if (insuranceType == 17) {
            const trafficAuthoritySelect = document.getElementById(
                "trafficAuthoritySelect",
            );

            if (trafficAuthoritySelect)
                trafficAuthoritySelect.style.cursor = "not-allowed";
        }
    };

    const _resetInputDisability = () => {
        const insuranceDetailsContainer = document.getElementById(
            "insuranceDetailsContainer",
        );

        const allInputs = insuranceDetailsContainer.querySelectorAll("input");

        allInputs.forEach((input) => (input.disabled = false));

        const allSelects = insuranceDetailsContainer.querySelectorAll("select");

        // const unlockIgnoreSelectIDs = [
        //     "patientInsuranceTypeSelect",
        //     "insuranceFundSelect",
        //     "insuranceAmaCoverTypeField",
        //     "insuranceAuhCoverTypeField",
        // ];

        // allSelects.forEach((select) => {
        //     if (!hasReceivedPayments) select.disabled = false;
        //     else if (unlockIgnoreSelectIDs.includes(select.id))
        //         select.disabled = true;
        //     else select.disabled = false;
        // });
        allSelects.forEach((select) => (select.disabled = false));

        const { insuranceType } = patientDetails;

        if (insuranceType == 0) {
            const insuranceFundSelect = document.getElementById(
                "insuranceFundSelect",
            );
            if (insuranceFundSelect) {
                insuranceFundSelect.style.cursor = "default";
                // insuranceFundSelect.style.cursor = hasReceivedPayments
                //     ? "not-allowed"
                //     : "default";
                // if (hasReceivedPayments) insuranceFundSelect.disabled = true;
            }
        } else if (insuranceType == 16) {
            const workerCompensationSelect = document.getElementById(
                "workerCompensationSelect",
            );

            if (workerCompensationSelect)
                workerCompensationSelect.style.cursor = "default";
        } else if (insuranceType == 17) {
            const trafficAuthoritySelect = document.getElementById(
                "trafficAuthoritySelect",
            );

            if (trafficAuthoritySelect)
                trafficAuthoritySelect.style.cursor = "default";
        }
    };

    const _setDefaultPrivateInsuranceDetails = () => {
        const { insuranceType } = patientDetails;

        __BACKUP__INSURANCE__TYPE__ = insuranceType;
    };

    const _openOpvResultModal = (res = {}) => {
        opvResult = { ...res, insuranceType: patientDetails.insuranceType };
        opvResultModalOpen = true;
    };

    const _closeOpvResultModal = () => {
        opvResult = {};
        opvResultModalOpen = false;
    };

    export const _setDefaultDoctorProvider = () => {
        if (!isObjectEmpty(selectedDoctorProvider)) return;
        var defaultProvider = $loggedInDoctorDetail.providers.find((p) => p.isDefault);
        selectedDoctorProvider.details = { 
            ...defaultProvider,
            selectLabel: `${defaultProvider.number}${defaultProvider.location ? ` (${defaultProvider.location})` : ""}`,
        };

        // when default provider is set and with no valid state, use default state
        patientDetails.insuranceState = selectedDoctorProvider.details.state
            ? selectedDoctorProvider.details.state.toUpperCase()
            : defaultState;

        onProviderChange();
    };

    const _setProviderState = (state) => {
        const allStates = AustralianStates.map((a) => a.key);
        if (state && allStates.includes(state)) {
            patientDetails.state = state;
            createSurgeonFilters.state = state;
        }
    };
</script>

<CardLayout title="Insurance Details" enableCollapse={false}>
    <div
        class="flex flex-col flex-1 p-4 w-full gap-y-4"
        id="insuranceDetailsContainer"
    >
        <div class="grid grid-cols-3 gap-y-4 w-full items-center">
            <div class="flex flex-1 col-span-2 gap-x-2 items-center">
                <p class="title">Doctor provider *:</p>
                <div class="flex flex-1" id="doctorProviderContainer">
                    <Select
                        bind:value={selectedDoctorProvider.details}
                        id="doctorProviderSelect"
                        class="flex flex-1 max-h-[35px] rounded-full"
                        items={($loggedInDoctorDetail.providers ?? []).map(p => ({
                                    ...p,
                                    selectLabel: `${p.number}${p.location ? ` (${p.location})` : ""}`,
                                }))}
                        itemId="id"
                        label="selectLabel"
                        on:clear={clearSelectedDoctorProvider}
                        on:change={onProviderChange}
                        disabled={isLoadingDoctor ||
                            (!UNLOCK_ALL_INPUTS &&
                                (disableInputScenario_ONE ||
                                    disableInputScenario_TWO))}
                        noOptionsMessage="No doctor provider found"
                        placeholder="Doctor provider"
                        --placeholder-color="#9CA3AF"
                        --height="32px"
                        --value-container-padding="0"
                        --padding="0 0 0 12px"
                        --font-size="14px"
                    >
                        <div slot="item" let:item>
                            <div class={item.isDefault ? "font-bold flex justify-between" : "flex justify-between"}>
                                <div>
                                    {item.number} {item.location ? `(${item.location})` : ""}
                                </div>
                                <div>
                                    {item.isDefault ? "Default" : ""}
                                </div>
                            </div>
                        </div>
                    </Select>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-3 gap-x-2 gap-y-4 w-full items-center">
            <!-- insurance type -->
            <div
                class={`flex gap-x-2 items-center ${showUnlockInsuranceInputTooltips ? "tooltip tooltip-secondary" : ""}`}
                data-tip={unlockInsuranceInputTooltip}
            >
                <p class="title text-left">Insurance Type *:</p>
                <select
                    class="select select-bordered select-sm flex-1"
                    id="patientInsuranceTypeSelect"
                    bind:value={patientDetails.insuranceType}
                    on:focus={({ target }) => (target.style.outline = "")}
                    on:change={_syncDisplayOptionsByState}
                    disabled={!UNLOCK_ALL_INPUTS && disableInputScenario_ONE}
                >
                    <option disabled>Insurance Type</option>
                    {#each InsuranceType.sort((a, b) => a.order - b.order).filter((insurance) => insurance.id != 26) as insurance}
                        {#if insurance.id != 25 && insurance.id != 26}
                            <option
                                value={insurance.id}
                                selected={insurance.id ==
                                    patientDetails.insuranceType}
                            >
                                {insurance.type}
                            </option>
                        {:else if patientDetails.insuranceType == 25}
                            <option value={Number(25)} selected>
                                Australian Defence Force
                            </option>
                        {:else if patientDetails.insuranceType == 26}
                            <option value={Number(26)} selected>
                                Australian Defence Force
                            </option>
                        {:else}
                            <option value={Number(25)}>
                                Australian Defence Force
                            </option>
                        {/if}
                    {/each}

                    {#if patientDetails.insuranceType == unknownPatientInsuranceType}
                        <option
                            value={unknownPatientInsuranceType}
                            selected
                            disabled
                        >
                            Unknown
                        </option>
                    {/if}
                </select>
            </div>

            {#if showPatientClaimCheckbox}
                <!-- <div class="flex gap-x-2 items-center pl-2">
                    <input
                        type="checkbox"
                        id="patientClaimCheckbox"
                        class="toggle toggle-secondary"
                        bind:checked={patientEncounterDetails.patientClaim}
                    />
                    <label
                        for="patientClaimCheckbox"
                        class="cursor-pointer pt-1"
                    >
                        Patient Claim
                    </label>

                    {#if showDownloadPatientClaimDocument}
                        <p
                            class="pt-1 text-sm cursor-pointer underline hover:font-bold"
                            on:click={handleDownloadPatientClaimDocument}
                        >
                            Download Patient Claim Consent and Declaration
                        </p>
                    {/if}
                </div> -->
            {:else if patientDetails.insuranceType == 16 || patientDetails.insuranceType == 17}
                <div class="flex gap-x-2 items-center">
                    <p class="title">State:</p>
                    <select
                        class="select select-bordered select-sm flex-1"
                        disabled={!UNLOCK_ALL_INPUTS &&
                            disableInputScenario_ONE}
                        bind:value={patientDetails.insuranceState}
                        on:change={_syncDisplayOptionsByState}
                    >
                        <option disabled>State</option>
                        {#each AustralianStates as state}
                            <option value={state.key}>{state.name}</option>
                        {/each}
                    </select>
                </div>
            {:else if patientDetails.insuranceType == 18}
                <div class="flex gap-x-2 items-center">
                    <p class="title">Select Insurer:</p>

                    {#if isLoadingThirdPartyInsurers}
                        <div class="flex items-center gap-x-2">
                            <Loader />
                            <p>Loading third-party insurers...</p>
                        </div>
                    {:else}
                        <Select
                            class="flex flex-1 max-h-[35px] rounded-full"
                            items={thirdPartyInsurers}
                            itemId="id"
                            label="name"
                            {groupBy}
                            noOptionsMessage="No Insurer Found"
                            placeholder="Insurer"
                            disabled={!UNLOCK_ALL_INPUTS &&
                                disableInputScenario_ONE}
                            on:select={_handleSelectThirdPartyInsurer}
                            --placeholder-color="#9CA3AF"
                            --height="32px"
                            --value-container-padding="0"
                            --padding="0 0 0 12px"
                            --font-size="14px"
                        />
                    {/if}
                </div>
            {/if}
        </div>

        {#if showWarningInsuranceInputText && __BACKUP__INSURANCE__TYPE__ != patientDetails.insuranceType}
            <p class="text-error">{warningInsuranceInputText}</p>
        {/if}

        <!-- medicare No., medicare Ref No. -->
        {#if patientDetails.insuranceType != 10 && patientDetails.insuranceType != 18 && patientDetails.insuranceType !== unknownPatientInsuranceType}
            <div class="grid grid-cols-3 gap-x-2 gap-y-4 w-full items-center">
                <div class="flex gap-x-2 items-center">
                    <p class="title">Medicare No.{![0, 11].includes(patientDetails.insuranceType) ? '' : ' *'}:</p>
                    <input
                        type="text"
                        id="patientMedicareNoField"
                        placeholder="Medicare No."
                        class="input input-sm input-bordered flex-1"
                        autocomplete="off"
                        maxlength="10"
                        bind:value={patientDetails.medicareNo}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Medicare No.";
                        }}
                        on:paste={(e) => {
                            e.preventDefault();

                            const pasted = e.clipboardData
                            .getData("text")
                            .replace(/\s|-/g, "") // remove spaces & dashes
                            .slice(0, 10);

                            patientDetails.medicareNo = pasted;
                        }}
                        on:input={({ target }) => {
                            patientDetails.medicareNo = target.value
                                .replaceAll(" ", "")
                                .replaceAll("-", "");
                        }}
                    />
                </div>

                <div class="flex gap-x-2 items-center">
                    <p class="title">Medicare Ref No.{![0,11].includes(patientDetails.insuranceType) ? '' : ' *'}:</p>
                    <input
                        type="text"
                        id="patientMedicareRefNoField"
                        placeholder="Medicare Ref No."
                        class="input input-sm input-bordered flex-1"
                        autocomplete="off"
                        bind:value={patientDetails.medicareRefNo}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Medicare Ref No.";
                        }}
                    />
                </div>

                {#if showOpvCheckBtn}
                    <div class="flex flex-row gap-x-2 items-center">
                        <p
                            class={`underline ${
                                isCheckingOPV
                                    ? "cursor-not-allowed"
                                    : "cursor-pointer"
                            }`}
                            on:click|preventDefault={runOpvCheck}
                        >
                            {isCheckingOPV ? "Checking" : "Run OPV Check"}
                        </p>
                        {#if isCheckingOPV}
                            <Loader />
                        {/if}
                    </div>
                {/if}
            </div>
        {/if}

        {#if patientDetails.insuranceType == 0 || patientDetails.insuranceType == 10}
            <div class="grid grid-cols-3 gap-x-2 gap-y-4 w-full items-center">
                <div
                    class={`flex gap-x-2 items-center ${showUnlockInsuranceInputTooltips ? "tooltip tooltip-secondary" : ""}`}
                    data-tip={unlockInsuranceInputTooltip}
                >
                    <p class="title text-left">Fund *:</p>

                    <div class="flex flex-1 w-remaining rounded-md" id="insuranceFundContainer">
                        {#if isLoadingInsuranceFund}
                            <div class="flex gap-x-2">
                                <p>Loading Insurance Fund</p>
                                <Loader />
                            </div>
                        {:else}
                            <Select
                                bind:value={insuranceDetails.insuranceFund} 
                                id="insuranceFundSelect"
                                class="flex flex-1 max-h-[35px] rounded-full"
                                items={patientDetails.insuranceType == 10 ? 
                                    [   defaultOverseasFund,
                                        ...$insuranceFund.filter((i) => i.isOverseas)] : 
                                    $insuranceFund}
                                itemId="id"
                                label="name"
                                on:clear={clearCurrentInsuranceFund}
                                on:select={handleSelectInsuranceFund}
                                noOptionsMessage="No insurance found"
                                placeholder="Insurance fund"
                                disabled={!UNLOCK_ALL_INPUTS &&
                                    (disableInputScenario_ONE ||
                                        disableInputScenario_TWO)}
                                --placeholder-color="#9CA3AF"
                                --height="32px"
                                --value-container-padding="0"
                                --padding="0 0 0 12px"
                                --font-size="14px"
                            />
                        {/if}
                    </div>
                </div>

                <!-- cover type -->
                {#if showCoverTypeForPrivateInsurance}
                    <div
                        class={`flex flex-1 gap-x-2 items-center ${showUnlockInsuranceInputTooltips ? "tooltip tooltip-secondary" : ""}`}
                        data-tip={unlockInsuranceInputTooltip}
                    >
                        <p class="title">Cover Type:</p>

                        <div class="flex items-center flex-1">
                            <select
                                class="select select-bordered select-sm flex flex-1"
                                id="insuranceAmaCoverTypeField"
                                disabled={!UNLOCK_ALL_INPUTS &&
                                    disableInputScenario_TWO}
                                bind:value={insuranceDetails.privateCoverType}
                            >
                                {#each getPrivateInsuranceFundCoverTypes(insuranceDetails.insuranceFund.id) as { value, displayName, isDefault }, index}
                                    <option
                                        {value}
                                        selected={insuranceDetails.privateCoverType ==
                                            value ||
                                            (!insuranceDetails.privateCoverType &&
                                                (isDefault || index == 0))}
                                    >
                                        {displayName}
                                    </option>
                                {/each}
                            </select>
                        </div>
                    </div>
                {/if}
            </div>

            {#if showWarningInsuranceInputText && __BACKUP__INSURANCE__TYPE__ == 0}
                <p class="text-error">{warningInsuranceInputText}</p>
            {/if}
        {/if}

        <div class="grid grid-cols-6 gap-x-2 gap-y-4 w-full items-start">
            {#if patientDetails.insuranceType == 0 || (patientDetails.insuranceType == 10 && insuranceDetails.insuranceFund?.id > 0)}
                <div class="flex items-center gap-x-2 col-span-2">
                    <p class="title">Membership No. *:</p>
                    <input
                        type="text"
                        id="insuranceDetailsMembershipNoField"
                        placeholder="Membership No"
                        class="input flex-1 input-sm input-bordered"
                        autocomplete="off"
                        bind:value={insuranceDetails.membershipNo}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Membership No";
                        }}
                    />
                </div>

                <div class="flex items-center gap-x-2 col-span-2">
                    <p class="title">Membership Ref No.:</p>
                    <input
                        type="text"
                        id="insuranceDetailsMembershipRefNoField"
                        placeholder="Membership Ref No"
                        class="input flex-1 input-sm input-bordered"
                        autocomplete="off"
                        bind:value={insuranceDetails.membershipRefNo}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Membership Ref No";
                        }}
                    />
                </div>
               
            {:else if patientDetails.insuranceType == 16}
                <div class="flex flex-col gap-y-2 col-span-2">
                    {#if isLoadingWorkerCompensation}
                        <div class="flex items-center gap-x-2">
                            <p>Loading Worker Insurer</p>
                            <Loader />
                        </div>
                    {:else}
                        <div class="w-full" id="workerCompensationContainer">
                            <Select
                                bind:value={workerCompensation}
                                id="workerCompensationSelect"
                                class="flex flex-1 max-h-[35px] rounded-full"
                                items={workerCompensationOptions}
                                itemId="id"
                                label="name"
                                on:clear={clearWorkerCompensation}
                                on:select={updateWorkcoverInsurerEmail}
                                noOptionsMessage="No compensation found"
                                placeholder="Workcover insurer (if known)"
                                disabled={(!UNLOCK_ALL_INPUTS &&
                                    disableInputScenario_TWO) ||
                                    !AustralianStates.some(
                                        ({ key }) =>
                                            key ==
                                            patientDetails.insuranceState.toUpperCase(),
                                    )}
                                --placeholder-color="#9CA3AF"
                                --height="32px"
                                --value-container-padding="0"
                                --padding="0 0 0 12px"
                                --font-size="14px"
                            />
                        </div>
                    {/if}

                    {#if workerCompensation?.id}
                        <input
                            type="text"
                            id="workerCompensationInsurerEmailInput"
                            placeholder="Workcover insurer email"
                            class="input w-full input-sm input-bordered"
                            autocomplete="off"
                            bind:value={workerCompensationObj.insurerEmail}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder = "Workcover insurer email";
                            }}
                        />

                        {#if !isValidInsurerEmail}
                            <!-- svelte-ignore a11y-label-has-associated-control -->
                            <label class="label">
                                <span class="label-text-alt text-error">
                                    Invalid email
                                </span>
                            </label>
                        {/if}
                    {/if}

                    <input
                        type="text"
                        class="input w-full input-sm input-bordered"
                        id="workerCompensationClaimNumberInput"
                        autocomplete="off"
                        placeholder="Worker compensation claim number"
                        bind:value={workerCompensationObj.claimNumber}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder =
                                "Worker compensation claim number";
                        }}
                    />

                    <div class="flex w-full item-center gap-x-2">
                        <input
                            type="checkbox"
                            id="skipWorkCoverClaimNoCheckbox"
                            class="toggle toggle-secondary"
                            bind:checked={skipWorkCoverClaimNo}
                            on:change={handleSkipWorkCoverClaimNo}
                        />
                        <label
                            for="skipWorkCoverClaimNoCheckbox"
                            class="pt-1 cursor-pointer"
                        >
                            {skipWcAndTacText}
                        </label>
                    </div>
                </div>

                <div class="divider divider-horizontal w-full">OR</div>

                <div class="flex flex-col gap-y-2 col-span-2">
                    <input
                        type="text"
                        id="insuranceDetailsEmployerField"
                        placeholder="Employer"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={insuranceDetails.employer}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Employer";
                        }}
                    />

                    <input
                        type="text"
                        id="insuranceDetailsEmployerEmailField"
                        placeholder="Employer email"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={insuranceDetails.employerEmail}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Employer email";
                        }}
                    />

                    {#if !isValidEmployerEmail}
                        <!-- svelte-ignore a11y-label-has-associated-control -->
                        <label class="label">
                            <span class="label-text-alt text-error">
                                Invalid email
                            </span>
                        </label>
                    {/if}
                </div>
            {:else if patientDetails.insuranceType == 17}
                {#if isLoadingTrafficAuthorities}
                    <div class="flex flex-1 items-center gap-x-2 col-span-full">
                        <p>Loading Traffic Authorities</p>
                        <Loader />
                    </div>
                {:else}
                    <div class="flex flex-col gap-y-2 col-span-2">
                        <div class="flex flex-1 gap-x-2">
                            <p class="title">Authority *:</p>
                            <div
                                class="flex-1 {!AustralianStates.some(
                                    ({ key }) =>
                                        key ==
                                        patientDetails.insuranceState.toUpperCase(),
                                )
                                    ? 'cursor-not-allowed'
                                    : ''}"
                                id="trafficAuthoritiesContainer"
                            >
                                <Select
                                    bind:value={trafficAuthority}
                                    id="trafficAuthoritySelect"
                                    class="flex flex-1 max-h-[35px] rounded-full"
                                    items={trafficAuthorityOptions}
                                    itemId="id"
                                    label="name"
                                    on:clear={clearTrafficAuthority}
                                    on:select={updateTrafficAuthorityEmail}
                                    noOptionsMessage="No authorities found"
                                    placeholder="Traffic Accident Authority"
                                    disabled={(!UNLOCK_ALL_INPUTS &&
                                        disableInputScenario_TWO) ||
                                        !AustralianStates.some(
                                            ({ key }) =>
                                                key ==
                                                patientDetails.insuranceState.toUpperCase(),
                                        )}
                                    --placeholder-color="#9CA3AF"
                                    --height="32px"
                                    --value-container-padding="0"
                                    --padding="0 0 0 12px"
                                    --font-size="14px"
                                />
                            </div>
                        </div>

                        {#if trafficAuthority?.id}
                            <div class="flex flex-col gap-y-2 flex-1">
                                <div class="flex flex-1 gap-x-2">
                                    <p class="title">Authority Email:</p>

                                    <input
                                        type="text"
                                        id="trafficAuthorityEmailInput"
                                        placeholder="Traffic Accident Authority email"
                                        class="input flex-1 input-sm input-bordered"
                                        autocomplete="off"
                                        bind:value={trafficAuthorityObj.email}
                                        on:focus={({ target }) => {
                                            target.style.outline = "";
                                            target.placeholder =
                                                "Traffic Accident Authority email";
                                        }}
                                    />
                                </div>

                                {#if !isValidTrafficAuthorityEmail}
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">
                                        <span class="label-text-alt text-error">
                                            Invalid email
                                        </span>
                                    </label>
                                {/if}
                            </div>
                        {/if}
                    </div>

                    <div class="flex flex-col gap-y-2 col-span-2">
                        <div class="flex gap-x-2 items-center">
                            <p class="title">Claim No. *:</p>
                            <input
                                type="text"
                                class="input flex-1 input-sm input-bordered"
                                id="trafficAuthorityClaimNumberInput"
                                autocomplete="off"
                                placeholder="Traffic Accident Authority claim number"
                                bind:value={trafficAuthorityObj.claimNumber}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder =
                                        "Traffic Accident Authority claim number";
                                }}
                            />
                        </div>

                        <div class="flex gap-x-2 items-center">
                            <input
                                type="checkbox"
                                id="skipTacClaimNoCheckbox"
                                class="toggle toggle-secondary"
                                bind:checked={skipTrafficAuthorityClaimNo}
                                on:change={handleSkipTacClaimNo}
                            />
                            <label
                                for="skipTacClaimNoCheckbox"
                                class="pt-1 cursor-pointer"
                            >
                                {skipWcAndTacText}
                            </label>
                        </div>
                    </div>
                {/if}
            {:else if patientDetails.insuranceType == 18}
                <div class="flex items-center gap-x-2 col-span-2">
                    <p class="title">Payer Name *:</p>
                    <input
                        type="text"
                        id="thirdPartyPayerNameInput"
                        placeholder="Payer name (mandatory)"
                        class="input flex-1 input-sm input-bordered"
                        autocomplete="off"
                        bind:value={thirdPartyPayerObj.name}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Payer name (mandatory)";
                        }}
                    />
                </div>

                <div class="flex items-center gap-x-2 col-span-4">
                    <p class="title">Payer Address *:</p>
                    <input
                        type="text"
                        id="thirdPartyPayerAddressInput"
                        placeholder="Payer address"
                        class="input flex-1 input-sm input-bordered"
                        autocomplete="off"
                        bind:value={thirdPartyPayerObj.address}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Payer address";
                            errInputs = removeErrorInput(
                                "thirdPartyPayerEmailInput",
                                errInputs,
                                "Payer email",
                            );
                        }}
                    />
                </div>

                <div class="flex flex-col col-span-2 gap-y-2">
                    <div class="flex flex-1 items-center gap-x-2">
                        <p class="title">Payer Email *:</p>

                        <input
                            type="text"
                            id="thirdPartyPayerEmailInput"
                            placeholder="Payer email"
                            class="input flex-1 input-sm input-bordered"
                            autocomplete="off"
                            bind:value={thirdPartyPayerObj.email}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder = "Payer email";
                                errInputs = removeErrorInput(
                                    "thirdPartyPayerAddressInput",
                                    errInputs,
                                    "Payer address",
                                );
                            }}
                        />
                    </div>

                    {#if !isValidThirdPartyPayerEmail}
                        <div class="flex flex-1 items-center gap-x-2">
                            <p class="title" />

                            <!-- svelte-ignore a11y-label-has-associated-control -->
                            <label class="label">
                                <span class="label-text-alt text-error">
                                    Invalid email
                                </span>
                            </label>
                        </div>
                    {/if}
                </div>

                <div class="flex flex-col col-span-2 gap-y-2">
                    <div class="flex flex-1 items-center gap-x-2">
                        <p class="title">Payer Phone No.:</p>

                        <input
                            type="text"
                            id="thirdPartyPayerPhoneNumberInput"
                            placeholder="Payer phone number"
                            class="input flex-1 input-sm input-bordered"
                            autocomplete="off"
                            bind:value={thirdPartyPayerObj.phone}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder = "Payer phone number";
                            }}
                        />
                    </div>

                    {#if !isValidThirdPartyPayerPhone}
                        <div class="flex flex-1 items-center gap-x">
                            <p class="title" />

                            <!-- svelte-ignore a11y-label-has-associated-control -->
                            <label class="label">
                                <span class="label-text-alt text-error">
                                    Invalid phone
                                </span>
                            </label>
                        </div>
                    {/if}
                </div>
                <div class="flex h-full items-center gap-x-2 col-span-2">
                    {#if $loggedInDoctorDetail == null || $loggedInDoctorDetail.isRegisteredForGST}
                            <p class="title text-right">Add GST</p>
                            <input
                                type="checkbox"
                                id="thirdPartyPayerAddGstCheckbox"
                                class="toggle toggle-secondary"
                                autocomplete="off"
                                bind:checked={thirdPartyPayerObj.addGST}
                            />
                    {/if}
                </div>
            {:else if patientDetails.insuranceType == 20}
                <div class="flex items-center gap-x-2 col-span-2">
                    <p class="title">Veteran No. *:</p>
                    <input
                        type="text"
                        id="insuranceDetailsDVANumberField"
                        placeholder="Veteran number"
                        class="input flex-1 input-sm input-bordered"
                        autocomplete="off"
                        bind:value={patientDetails.veteranNo}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Veteran number";
                        }}
                    />
                </div>
            {:else if patientDetails.insuranceType == 25 || patientDetails.insuranceType == 26}
                <div class="flex items-center gap-x-2 col-span-2">
                    <p class="title">PID *:</p>
                    <input
                        type="text"
                        id="insuranceDetailsPIDField"
                        placeholder="PID"
                        class="input flex-1 input-sm input-bordered"
                        autocomplete="off"
                        bind:value={defenceDataObj.pid}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "PID";
                        }}
                    />
                </div>
                <div class="flex items-center gap-x-2 col-span-2">
                    <p class="title">DAN *:</p>
                    <input
                        type="text"
                        id="insuranceDetailsDANField"
                        placeholder="DAN"
                        class="input flex-1 input-sm input-bordered"
                        autocomplete="off"
                        bind:value={defenceDataObj.dan}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "DAN";
                        }}
                    />
                </div>

                <div class="flex items-center gap-x-2 col-span-6">
                    <input
                        type="checkbox"
                        id="skipDefenceCheckbox"
                        class="toggle toggle-secondary"
                        bind:checked={skipDefenceClaimNo}
                        on:change={handleSkipDefenceClaimNo}
                    />
                    <label
                        for="skipDefenceCheckbox"
                        class="pt-1 cursor-pointer"
                    >
                        {skipDefenceText}
                    </label>
                </div>
            {:else if patientDetails.insuranceType == 30}
                <div class="flex flex-col gap-y-2 col-span-2">
                    <div class="flex items-center gap-x-2">
                        <p class="title">Email:</p>
                        <input
                            type="text"
                            id="pipEmailInput"
                            placeholder="Email to send invoice"
                            class="input flex-1 input-sm input-bordered"
                            autocomplete="off"
                            bind:value={publicInPrivateObj.email}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder = "Email to send invoice";
                            }}
                        />
                    </div>
                    {#if !isValidPipEmail}
                        <div class="flex flex-1 items-center gap-x-2">
                            <p class="title" />

                            <!-- svelte-ignore a11y-label-has-associated-control -->
                            <label class="label">
                                <span class="label-text-alt text-error">
                                    Invalid email
                                </span>
                            </label>
                        </div>
                    {/if}
                </div>

                <div class="flex gap-x-2 col-span-2">
                    <p class="title">Vendor No.:</p>

                    <input
                        type="text"
                        id="pipVendorInput"
                        placeholder="Vendor number (if applicable)"
                        class="input flex-1 input-sm input-bordered"
                        autocomplete="off"
                        bind:value={publicInPrivateObj.vendorNumbers}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder =
                                "Vendor number (if applicable)";
                        }}
                    />
                </div>
            {/if}

            {#if patientDetails.insuranceType == 10 && insuranceDetails.insuranceFund?.id == 0}
                <div class="flex flex-1 items-center gap-x-2 col-span-6">
                    <p class="title">Fund details:</p>
                    <input
                        type="text"
                        id="insuranceDetailsOverseasCoverField"
                        placeholder="Insurance details"
                        class="input input-sm input-bordered flex-1"
                        autocomplete="off"
                        bind:value={insuranceDetails.overseasCover}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Insurance details";
                        }}
                    />
                </div>
            {/if}
        </div>
    </div>
</CardLayout>

<OpvStatusModal
    {opvResult}
    isModalOpen={opvResultModalOpen}
    closeModal={_closeOpvResultModal}
/>

<style>
    .title {
        width: 10rem;
    }

    /*  11 rem to include also padding between items */
    .w-remaining {
        width: calc(100% - 11rem);
    }
</style>
